/**
 * <s-countdown data-end="ISO date"> updates its [data-unit] children every second.
 */
class CountdownElement extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    this.units = {};
    this.querySelectorAll('[data-unit]').forEach((el) => {
      this.units[el.dataset.unit] = el;
    });
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Number.isNaN(this.end) ? 0 : Math.max(0, this.end - Date.now());
    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const el = this.units[unit];
      if (el) el.textContent = String(value).padStart(2, '0');
    }
    if (remaining === 0) clearInterval(this.#timer);
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', CountdownElement);
}
